/**
 * Downloads the provided `data` (array of objects) as a CSV file named `filename`.
 */
export function exportToCsv(
    data: any[],
    cols: string[],
    filename = "data.csv"
  ) {
    if (!data.length) return;
    const header = cols.join(",");
    const rows = data.map((row) =>
      cols
        .map((c) => {
          const v = row[c];
          if (v == null) return "";
          if (typeof v === "string") return `"${v.replace(/"/g, '""')}"`;
          return String(v);
        })
        .join(",")
    );
    const csv = [header, ...rows].join("\r\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  
  /**
   * Copies provided `data` (array of objects) as CSV-formatted text to clipboard.
   */
  export function copyToClipboardCsv(data: any[], cols: string[]) {
    if (!data.length) return;
    const header = cols.join(",");
    const rows = data.map((row) =>
      cols
        .map((c) => {
          const v = row[c];
          if (v == null) return "";
          if (typeof v === "string") return `"${v.replace(/"/g, '""')}"`;
          return String(v);
        })
        .join(",")
    );
    const csv = [header, ...rows].join("\n");
    navigator.clipboard.writeText(csv);
  }
  